export enum FeatureTypes {
    Batch   = "batch",
    Project = "project",
}

